import { uniqueId } from "lodash";
import { Note, SearchNotOrdered } from "../types";

export const buildTempNote = (text: string, entity: SearchNotOrdered, name: string): Note =>
  ({
    id: parseFloat(uniqueId()),
    uniqueIdentifier: entity.uniqueIdentifier,
    orderNumber: entity.orderNumber,
    createdByUser: name,
    text,
    dateCreated: new Date(),
    createdBy: name
  } as Note);
